import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class InsuranceCompanyService {

  constructor(private http: HttpClient) { }

  getAllInsuranceCompaniesPaged(page, size): Observable<any> {
    return this.http.get(mainUrl + `company/paged?page=${page}&size=${size}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllInsuranceCompanies(): Observable<any> {
    return this.http.get(mainUrl + `company`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getInsuranceCompanyById(id): Observable<any> {
    return this.http.get(mainUrl + `company/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createInsuranceCompany(form): Observable<any> {
    return this.http.post(mainUrl + 'company', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  editInsuranceCompany(form, id): Observable<any> {
    return this.http.put(mainUrl + `company/${id}`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllUsersByInsuranceCompanyPaged(id, page, size): Observable<any> {
    return this.http.get(mainUrl + `company/users/paged/${id}?page=${page}&size=${size}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllUsersByInsuranceCompany(id): Observable<any> {
    return this.http.get(mainUrl + `company/users/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteCompany(id): Observable<any> {
    return this.http.delete(mainUrl + `company/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createInsuranceCompanyUser(form): Observable<any> {
    return this.http.post(mainUrl + `company/carrier`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  editInsuranceCompanyUser(form, id): Observable<any> {
    return this.http.put(mainUrl + `company/carrier/${id}`, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteInsuranceCompanyUser(id): Observable<any> {
    return this.http.delete(mainUrl + `company/carrier/${id}`)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getInsuranceCompanyReport(): Observable<any> {
    return this.http.post(mainUrl + `company/report`, {}, { reportProgress: true, observe: 'response', responseType: 'blob' })
      .pipe(
        timeout(30000),
        map((res: any) => res.body)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
    });

    return headers;
  }
}